/** @param {{ roles?: string[] } | null | undefined} user */
export function isOwner(user) {
  return Boolean(user?.roles?.some((r) => r === "ROLE_OWNER" || r === "ROLE_ADMIN"))
}

/** @param {{ roles?: string[] } | null | undefined} user */
export function isCoach(user) {
  return Boolean(user?.roles?.includes("ROLE_COACH"))
}

/** @param {{ roles?: string[] } | null | undefined} user */
export function isEmployee(user) {
  return Boolean(user?.roles?.includes("ROLE_EMPLOYEE"))
}

/** Coach sans rôle employé / admin : vue planning et cours uniquement */
export function isPureCoach(user) {
  if (!user?.roles?.length) return false
  const r = user.roles
  if (r.includes("ROLE_OWNER") || r.includes("ROLE_ADMIN") || r.includes("ROLE_EMPLOYEE")) {
    return false
  }
  return r.includes("ROLE_COACH")
}

/** Accès zone équipe / cours / calendrier (lecture) */
export function canViewTeamArea(user) {
  return isOwner(user) || isEmployee(user) || isCoach(user)
}

/** Liste employés : pas affichée aux coachs « purs » */
export function canViewEmployeeDirectory(user) {
  return canViewTeamArea(user) && !isPureCoach(user)
}

/** Gestion CRUD employés, coachs, cours, comptes */
export function canManageTeamAndCourses(user) {
  return isOwner(user)
}

/** Membres, paiements, abonnements, dépenses (hors coach pur) */
export function canViewFinanceArea(user) {
  return !isPureCoach(user)
}
